import * as React from 'react';

import Form, { FormComponentProps } from 'antd/lib/form';
import styled from 'styled-components';
import FormControl from '../../Forms/FormControl';



export const StyleIpoApplicationForm = styled(Form)`

    .text-content-justified {
        text-align: justify;
        line-height: 25px;
    }

    .amount-payable {
        text-align: left;
        margin-bottom: 10px;
        padding-left: 10px;
    }

  .login-form-forgot {
    float: left;
  }

  .login-form-sign-up{
    float: right;
  }

  .login-form-button {
    width: 100%;
    background-color: rgb(174, 24, 87);
  }
`;






